import React, { createContext, useContext, useEffect, useState } from 'react';
import commonApi from '../utils/api';
import { useNavigate } from 'react-router-dom';
import { CommonContext } from './CommonContext';
import { format } from 'date-fns';

export const NDRContext = createContext();

const initialFilters = {
    searchBy: 'awb_no',
    searchValue: '',
    merchant_id: [],
    courier_id: [],
    dateRange: {
        startDate: new Date(),
        endDate: new Date()
    },
    type: 1,
};
const tabOptions = [
    { label: "All", value: 1 },
    { label: "Action Required", value: 2 },
    { label: "Action Requested", value: 3 },
];
export const NDRContextProvider = ({ children }) => {
    const { user, setAlertMessage, setOpenAlert, setSeverity, globalSearch, setModalAlert } = useContext(CommonContext);
    const navigate = useNavigate();

    const [filters, setFilters] = useState(initialFilters);
    const [activeTab, setActiveTab] = useState(tabOptions[0].value);
    const [addModal, setAddModal] = useState(false);
    const [addNewModal, setAddNewModal] = useState(false);
    const [ndrCodesModal, setNdrCodesModal] = useState(false);
    const [isPanelOpen, setIsPanelOpen] = useState(false);
    const [selected, setSelected] = useState([]);
    const [allData, setAllData] = useState([]);
    const [allNDR, setAllNDR] = useState([]);
    const [firstLoading, setFirstLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [cancelDialog, setCancelDialog] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [formDataTemp, setFormDataTemp] = useState({
        action: '',
        file: null,
    });

    const handleAddModal = () => {
        setAddModal(true);
    };

    const handleCloseModal = () => {
        setAddModal(false);
        setModalAlert(false);
        setAlertMessage("");
    };

    const handleAddNewModal = () => {
        setAddNewModal(true);
    };

    const handleCloseNewModal = () => {
        setAddNewModal(false);
        setModalAlert(false);
        setAlertMessage("");
    };

    const handleNDRCodesModalOpen = () => {
        setNdrCodesModal(true);
    };

    const handleNDRCodesModalClose = () => {
        setNdrCodesModal(false);
    };
    const handlePanelOpen = () => {
        setIsPanelOpen(true);
    };

    const handlePanelClose = () => {
        setIsPanelOpen(false);
        setFormDataTemp({
            action: '',
            file: null,
        });
    };


    // console.log('filters', filters);
    const onLoadApi = (customFilters = filters) => {
        const payload = {
            ...customFilters,
            start_date: customFilters?.dateRange?.startDate
                ? format(new Date(customFilters.dateRange.startDate), 'yyyy-MM-dd')
                : null,
            end_date: customFilters?.dateRange?.endDate
                ? format(new Date(customFilters.dateRange.endDate), 'yyyy-MM-dd')
                : null,
        };

        if (globalSearch?.value) {
            payload.searchBy = 'awb_no';
            payload.searchValue = globalSearch?.value;
            payload.start_date = '';
            payload.end_date = '';
            setFilters((prev) => ({ ...prev, searchBy: 'awb_no', searchValue: globalSearch?.value, dateRange: { startDate: null, endDate: null } }));
        }

        delete payload.dateRange;
        setAllData([]);
        setAllNDR([]);
        setFirstLoading(false);
        commonApi.post(`/ndr/list?page=${page + 1}&per_page=${rowsPerPage}`, payload)
            .then((response) => {
                setFirstLoading(true);
                if (response?.data?.data) {
                    setAllNDR(response?.data?.data);
                    setAllData(response?.data);
                }
            })
            .catch((error) => {
                setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };

    const onExport = (customFilters = filters) => {
        const payload = {
            ...customFilters,
            start_date: customFilters?.dateRange?.startDate
                ? format(new Date(customFilters.dateRange.startDate), 'yyyy-MM-dd')
                : null,
            end_date: customFilters?.dateRange?.endDate
                ? format(new Date(customFilters.dateRange.endDate), 'yyyy-MM-dd')
                : null,
        };
        if (user?.user_type !== "Merchant") {
            payload.admin_id = user?.id
        } else {
            payload.merchant_id = user?.id
        }
        delete payload.dateRange;
        setIsLoading(true);
        console.log('export payload', payload);
        commonApi.post('/ndr/export', payload)
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    navigate('/download');
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
                setOpenAlert(true);
                setAlertMessage(error?.message || 'Something went wrong');
                setSeverity('error')
            });
    };

    useEffect(() => {
        if (globalSearch.searchTrigger > 0) {
            onLoadApi();
            // Reset search flag after handling
            // You might want to reset this in context or here
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [globalSearch.searchTrigger]);
    // Fetch initial data when the context is created
    useEffect(() => {
        onLoadApi();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, rowsPerPage, activeTab]);


    const onCalling = (row) => {
        setIsLoading(true);
        const postReq = {
            order_id: row?.order_id ?? row?.orderId ?? '',
            awb_no: row?.awb_no ?? '',
            customer_mobile: row?.order?.customer_mobile ?? '',
            ivr_mobile: user?.ivr_mobile ?? ''
        };
        commonApi.post('ivr/clickToCall', postReq)
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.s === 1) {
                    setOpenAlert(true);
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                } else {
                    setOpenAlert(true);
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error');
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setOpenAlert(true);
                setAlertMessage(error?.response?.data?.msg || error?.message || 'Error occurred');
                setSeverity('error');
            });
    };

    const contextValue = {
        onCalling,
        formDataTemp,
        setFormDataTemp,
        isPanelOpen,
        handlePanelOpen,
        handlePanelClose,
        onExport,
        addModal,
        handleAddModal,
        handleCloseModal,
        addNewModal,
        handleAddNewModal,
        handleCloseNewModal,
        ndrCodesModal,
        handleNDRCodesModalOpen,
        handleNDRCodesModalClose,
        initialFilters,
        allData,
        setAllData,
        allNDR,
        setAllNDR,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
        firstLoading,
        setFirstLoading,
        cancelDialog,
        setCancelDialog,
        isLoading,
        setIsLoading,
        onLoadApi,
        selected,
        setSelected,
        tabOptions,
        activeTab,
        setActiveTab,
        filters,
        setFilters,
    };
    return (
        <NDRContext.Provider value={contextValue}>
            {children}
        </NDRContext.Provider>
    );
};

